export var version = "3.12.4";
//# sourceMappingURL=version.js.map